import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbTrail = () => {
  const location = useLocation();
  
  const pathMap = {
    '/home-dashboard': 'หน้าหลัก',
    '/organization-structure': 'โครงสร้างองค์กร',
    '/news-and-announcements': 'ข่าวประชาสัมพันธ์',
    '/public-services-portal': 'บริการประชาชน',
    '/complaint-submission': 'ยื่นเรื่องร้องเรียน'
  };

  const generateBreadcrumbs = () => {
    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [
      { label: 'หน้าหลัก', path: '/home-dashboard', isHome: true }
    ];

    let currentPath = '';
    pathSegments?.forEach((segment) => {
      currentPath += `/${segment}`;
      if (currentPath !== '/home-dashboard' && pathMap?.[currentPath]) {
        breadcrumbs?.push({
          label: pathMap?.[currentPath],
          path: currentPath,
          isHome: false
        });
      }
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  return (
    <nav 
      className="flex items-center space-x-2 text-sm text-muted-foreground py-3"
      aria-label="เส้นทางการนำทาง"
    >
      {breadcrumbs?.map((crumb, index) => (
        <React.Fragment key={crumb?.path}>
          {index > 0 && (
            <Icon 
              name="ChevronRight" 
              size={16} 
              className="text-muted-foreground/60"
            />
          )}
          {index === breadcrumbs?.length - 1 ? (
            <span 
              className="text-foreground font-medium truncate"
              aria-current="page"
            >
              {crumb?.label}
            </span>
          ) : (
            <Link
              to={crumb?.path}
              className="
                hover:text-primary transition-government truncate
                focus:outline-none focus:ring-2 focus:ring-accent 
                focus:ring-offset-1 rounded px-1 py-0.5
              "
            >
              {crumb?.isHome && (
                <Icon name="Home" size={14} className="inline mr-1" />
              )}
              {crumb?.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default BreadcrumbTrail;